import { styled } from 'styled-components';

import { media } from '@/utils/mediaQueries';

interface ImagePreviewCardProps {
  isLarge?: boolean;
}

export const ImagePreviewCard = styled.div<ImagePreviewCardProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: ${({ isLarge }) => (isLarge ? '100%' : '150px')};
  width: ${({ isLarge }) => (isLarge ? 'auto' : '150px')};
  padding: 10px 5px;
  border: 1px solid #e5e5e5;
  border-radius: 6px; 
  box-sizing: border-box;
  background-color: #f5f5f5;
    &:hover > span {
        display: flex;
    }
  img {
    width: ${({ isLarge }) => (isLarge ? '100%' : 'auto')};
    max-height: ${({ isLarge }) => (isLarge ? 'auto' : '140px')};
    object-fit: cover;
  }
`;

export const PdfPreviewCard = styled.div<ImagePreviewCardProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: ${({ isLarge }) => (isLarge ? '100%' : '40px')}; 
  padding: 0px 0px;
  border-radius: 6px; 
  box-sizing: border-box; 
    &:hover > span {
        display: flex;
    }
  img {
    width: ${({ isLarge }) => (isLarge ? '100%' : 'auto')};
    max-height: ${({ isLarge }) => (isLarge ? 'auto' : '50px')};
    object-fit: cover;
  }
`;

export const Text = styled.div`
  font-size: 13px;
  color: #505050;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
`;

export const RemovePdfButton = styled.span`
    position: absolute;
    top:-5px;
    right: -5px;
    z-index: 99;
    width: 17px;
    display: none;
    align-items: center;
    justify-content: center;
    height: 17px;
    border-radius: 50%;
    background:#fdd0df;
    cursor: pointer; 
    border: 1px solid #f54180;
  `;

export const RemoveImageButton = styled.span`
    position: absolute;
    top:-5px;
    right: -5px;
    z-index: 99;
    width: 20px;
    display: none;
    align-items: center;
    justify-content: center;
    height: 20px;
    border-radius: 50%;
    background:#fdd0df;
    cursor: pointer; 
    border: 1px solid #f54180;

    /* Dotyk (brak hover): akcje zawsze widoczne. */
    ${media.touch} {
        display: flex;
    }
  `;

export const PreviewTitle = styled.p`
    font-size: 15px;
    font-weight: 500;
    color: #11181c;
    margin: 0;
    width: 260px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    padding-bottom: 10px;
`;
